import type { ReactNode } from "react";
import { ConsumerFooter } from "./consumer-footer";
import { ConsumerHeader } from "./consumer-header";

interface ConsumerLayoutProps {
  children: ReactNode;
  headerContent?: ReactNode;
  compactNav?: boolean;
  transparentHeader?: boolean;
  mobileSearchOnly?: boolean;
  mobileLeftAction?: ReactNode;
  mobileRightAction?: ReactNode;
  hideFooter?: boolean;
}

function ConsumerLayout({
  children,
  headerContent,
  compactNav,
  transparentHeader,
  mobileSearchOnly,
  mobileLeftAction,
  mobileRightAction,
  hideFooter,
}: ConsumerLayoutProps) {
  return (
    <div className="flex min-h-[var(--visual-vh,100vh)] flex-col">
      <ConsumerHeader
        headerContent={headerContent}
        compactNav={compactNav}
        transparent={transparentHeader}
        mobileSearchOnly={mobileSearchOnly}
        mobileLeftAction={mobileLeftAction}
        mobileRightAction={mobileRightAction}
      />
      <main className="flex-1">{children}</main>
      {!hideFooter && <ConsumerFooter />}
    </div>
  );
}

export { ConsumerLayout, type ConsumerLayoutProps };
